<template>
  <li>
    <div class="reviewCard contentsWrap" href="">
      <div class="iconWithName">
        <div class="icon">
          <img :src="src(review.user.image_url)">
        </div>
        <div class="name">{{ review.user.name }}</div>
        <content-info
            v-if="showInfo(review)"
            :user-id="review.user_id"
            :content-type="1"
            :content-id="review.id"
        ></content-info>
      </div>
      <!-- <review-stars :stars="review.review" wrap-class="reviewStars"></review-stars> -->
      <h3 class="title">{{ review.title }}</h3>
      <slide-photos :photos='review.photos' :imagePath="image_path" customClass="reviewPhoto"></slide-photos>
      <p class="content" v-if="!open">
        {{ content }}
        <span class="more" v-if="review.content.length > contentLength" @click.prevent="open = !open">…もっと見る</span>
      </p>
      <p class="content" v-if="open">
        {{ review.content }}
        <span class="more" v-if="review.content.length > contentLength" @click.prevent="open = !open">閉じる</span>
      </p>
      <div class="date">{{ review.created_at }}</div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    review: Object,
    image_path: String,
    is_login: Boolean,
    user: Object
  },
  computed: {
    content() {
      return this.review.content.substr(0, this.contentLength)
    }
  },
  data: () =>({
    contentLength: 50,
    open: false
  }),
  methods: {
    src(url) {
      if (url === null) {
        return '/img/aloco_img_2.svg'
      } else {
        return this.image_path + url;
      }
    },
    showInfo(review) {
      if (this.user) {
        if (this.is_login && this.user.id !== review.user_id) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss">
.title, .content {
  white-space: pre-line;
  word-break: break-all;
}
.reviewCard {
  .content {
    white-space: pre-line;
    height: auto;
    overflow: unset;
    max-height: none;
  }
  .reviewStars {
    margin-top: 1rem;
  }
  .date {
    margin-top: 16px;
    color: #848484;
    font-size: 12px;
  }
}
</style>
